import { SelectedTextReadRate, StoryState } from '@common/store/story/models/story.models';
import { createReducer, on } from '@ngrx/store';
import { StoriesRecordActions } from '@src/suite/common/store/records/records.actions';
import { StoryActions, StoryHttpActions } from '@src/suite/common/store/story/actions/story.actions';

export const initialState: StoryState = {
    prompts: [],
    lockState: new Map<string, { state: boolean; editors: string[] }>(),
    lockInProgress: new Map<string, boolean>(),
    shouldRequireLock: new Map<string, boolean>(),
    selectedText: new Map<string, SelectedTextReadRate>(),
};

export const storiesReducer = createReducer(
    initialState,
    on(StoryHttpActions.loadPromptsSuccess, (state, action): StoryState => {
        return { ...state, prompts: action.data };
    }),
    on(StoryHttpActions.lockStory, (state, action): StoryState => {
        const lockState = new Map(state.lockState);
        const lockInProgress = new Map(state.lockInProgress);
        const storyLockState = lockState.get(action.storyGuid);
        const shouldRequireLock = new Map(state.shouldRequireLock);
        shouldRequireLock.delete(action.storyGuid);

        if (!storyLockState || storyLockState.state === false || storyLockState.editors.length === 0) {
            lockState.set(action.storyGuid, { state: false, editors: [action.editorGuid] });
            lockInProgress.set(action.storyGuid, true);
        } else {
            if (!storyLockState.editors.find(guid => guid === action.editorGuid)) {
                storyLockState.editors.push(action.editorGuid);
            }
        }
        return {
            ...state,
            lockInProgress: lockInProgress,
            lockState: lockState,
            shouldRequireLock: shouldRequireLock,
        };
    }),
    on(StoryHttpActions.lockStorySuccess, (state, action): StoryState => {
        const lockState = new Map(state.lockState);
        const lockInProgress = new Map(state.lockInProgress);
        const storyLockState = lockState.get(action.storyGuid);

        if (!storyLockState) {
            lockState.set(action.storyGuid, { state: true, editors: [action.editorGuid] });
        } else {
            storyLockState.state = true;
            if (!storyLockState.editors.find(guid => guid === action.editorGuid)) {
                storyLockState.editors.push(action.editorGuid);
            }
        }
        lockInProgress.set(action.storyGuid, false);
        return {
            ...state,
            lockInProgress: lockInProgress,
            lockState: lockState,
        };
    }),
    on(StoryHttpActions.lockStoryError, (state, action): StoryState => {
        const lockState = new Map(state.lockState);
        const lockInProgress = new Map(state.lockInProgress);
        const storyLockState = lockState.get(action.storyGuid);

        if (!storyLockState) {
            lockState.set(action.storyGuid, { state: false, editors: [action.editorGuid] });
        } else {
            storyLockState.state = false;
            if (!storyLockState.editors.find(guid => guid === action.editorGuid)) {
                storyLockState.editors.push(action.editorGuid);
            }
        }
        lockInProgress.set(action.storyGuid, false);
        return {
            ...state,
            lockInProgress: lockInProgress,
            lockState: lockState,
        };
    }),
    on(StoryHttpActions.releaseStoryLock, (state, action): StoryState => {
        const lockState = new Map(state.lockState);
        const storyLockState = lockState.get(action.storyGuid);

        if (storyLockState) {
            if (action.editorGuid === '@all') {
                storyLockState.editors = [];
            } else {
                storyLockState.editors = [...storyLockState.editors.filter(guid => guid !== action.editorGuid)];
            }
        }
        return {
            ...state,
            lockState: lockState,
        };
    }),
    on(StoryHttpActions.releaseStoryLockSuccess, (state, action): StoryState => {
        const lockState = new Map(state.lockState);
        const lockInProgress = new Map(state.lockInProgress);

        lockState.delete(action.storyGuid);
        lockInProgress.delete(action.storyGuid);
        return {
            ...state,
            lockState: lockState,
        };
    }),
    on(StoryActions.requireLock, (state, action): StoryState => {
        const shouldRequireLock = new Map(state.shouldRequireLock);
        shouldRequireLock.set(action.storyGuid, true);
        return {
            ...state,
            shouldRequireLock: shouldRequireLock,
        };
    }),
    on(StoriesRecordActions.setReadRateTime, (state, action: { storyGuid: string; selectedReadRate: SelectedTextReadRate }): StoryState => {
        const selectedText = new Map(state.selectedText);
        selectedText.set(action.storyGuid, action.selectedReadRate);
        return {
            ...state,
            selectedText: selectedText,
        };
    })
);
